/** Whether an element is Fun's: it portals its checkout and menus to `<body>`, marked `data-rk` or in a shadow host. */
export const isFunElement = (element: Element) =>
  element.hasAttribute("data-rk") || element.hasAttribute("data-funkit-shadow-host");

/**
 * Fun's roots in the document (shadow host, theme roots, menus), for handing them focus. The SDK's
 * theme wrapper also renders in place inside the open dialog, so dialog content is skipped.
 */
export const FUN_OVERLAY_ELEMENTS = (): Element[] =>
  Array.from(document.querySelectorAll("[data-funkit-shadow-host], [data-rk]")).filter(
    (el) => !el.closest("[data-modal-id]"),
  );
